import { SCREEN_NAMES } from './screen-names.js';

const ACTION_LABELS: Readonly<Record<string, string>> = {
  view: 'See',
  edit: 'Create & edit',
  delete: 'Delete',
};

function humanize(camelCase: string): string {
  const words = camelCase.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
}

/** A permission key as people read it: `salesOrder:view` → "Sales Orders · See". */
export function permissionLabel(permission: string): string {
  const [moduleKey = '', action = ''] = permission.split(':');
  const screen = SCREEN_NAMES[moduleKey] ?? humanize(moduleKey);
  return `${screen} · ${ACTION_LABELS[action] ?? humanize(action)}`;
}
